<template>
  <v-container fluid>
    
    <!-- 프로그레스 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="loading" max-width="300px">
        <v-container class="d-flex flex-column justify-center align-center" 
                     style="background-color:white;width:300px;height:300px">
          <v-row class="ma-8">
            <v-progress-circular
              :size="100"
              :width="15"
              color="purple"
              indeterminate
              >
            </v-progress-circular>
          </v-row>
          <v-row class="ma-5">
            <label style="text-align:center">잠시만 기다려주세요</label>
          </v-row>
        </v-container >
      </v-dialog>
    </v-row>

    <v-row align="center" justify="end" v-if="this.$uselan">
      <v-select style="widht:100px;max-width:100px;margin-right:10px;font-size:12px"
        solo dense hide-details
        v-model="$i18n.locale" :items="$lanlist" item-text="name" item-value="value" @change="changelan" />
    </v-row>
    
    <v-row align="center" justify="center">
      <v-col cols="12" md="4" sm="12" xs="12">
        <template v-if="this.$hostname == 'admin.mnccom-reg.com'">
          <v-img src="../assets/mnclogo.png" class="mt-15"></v-img>
        </template>
        <template v-else-if="this.$hostname == 'admin.pictcloud.com'">
          <v-img src="../assets/pictlogo.png" class="mt-15"></v-img>
        </template>
        <template v-else>
          <v-img src="../assets/logo.png" class="mt-15"></v-img>
        </template>
      </v-col>
    </v-row>
    
    <template v-if="this.$hostname == 'admin.mnccom-reg.com'">
    </template>
    <template v-else-if="this.$hostname == 'admin.pictcloud.com'">
    </template>
    <template v-else>
      <v-row align="center" justify="center">
        <template v-if="this.$i18n.locale == 'ko'">
          <p style="color:black;display:inline;font-size:22px;font-weight:bold">전시, 박람회, 컨퍼런스 입장권 발급은&nbsp;</p><p style="color:#4e6ef7;display:inline;font-size:22px;font-weight:bold"><strong>페어패스</strong></p><p class="text-center" style="color:black;display:inline;font-size:22px;font-weight:bold">로 PASS!</p>
        </template>
        <template v-else>
          <p style="color:black;display:inline;font-size:22px;font-weight:bold">Tickets for exhibitions, fairs, and conferences are issued via&nbsp;</p><p style="color:#4e6ef7;display:inline;font-size:22px;font-weight:bold"><strong>FAIRPASS</strong></p>
        </template>
      </v-row>
    </template>
    <v-row class="mt-15" style="background:#4e6ef7;height:100px" align="center" justify="center">
    </v-row>   
    
    <v-row style="background:#4e6ef7;" align="center" justify="center">
      <v-col cols="12" md="4" sm="10" xs="10">
        <div class="roundbg text-center">  
            <p id="login_title" style="color:#4e6ef7;font-size:20px;font-weight:bold" class="text-center">{{ $t("login_title") }}</p>

            <v-text-field 
              outlined v-model="user_id" prepend-inner-icon="mdi-account-circle-outline" 
              name="login" :placeholder="$t('login_id')" 
              color="#4e6ef7" hide-details
            type="text" dense></v-text-field>

            <v-text-field 
            class="mt-5"
            outlined @keyup.enter="login" v-model="user_pw" prepend-inner-icon="lock" 
            name="password" :placeholder="$t('login_pw')" id="password" 
            type="password" dense color="#4e6ef7" hide-details></v-text-field>
            
            <v-checkbox
                  v-model="checkbox"
                  :label="$t('login_save')" dense @change="checkchange"
                ></v-checkbox>            

            <v-btn  
            class="mt-5"
            style="height:35px;width:200px;font-size:18px;color:white" color="#4f6df6" rounded @click="login">{{ $t('login_btn') }}</v-btn>

        </div>
      </v-col>
    </v-row>
    <v-row style="background:#4e6ef7" align="center" justify="center">
      <v-col cols="12" md="12" sm="12" xs="12">
        <p id="login_title" style="color:white;font-size:13px" class="text-center">{{ $t('login_info') }}</p>
      </v-col>
    </v-row>   


    <v-row style="background:#4e6ef7" align="center" justify="center">
      <v-col cols="3" md="2" sm="3" xs="3" align="center">
        <a style="color:white;font-size:16px" class="text-center" @click="runjoin">{{ $t('login_join') }}</a>
      </v-col>
      <v-col cols="3" md="2" sm="3" xs="3" align="center">
        <a style="color:white;font-size:16px" class="text-center" @click="runpass">{{ $t('login_pwfind') }}</a>
      </v-col>
    </v-row>   

    <v-row style="background:#4e6ef7;height:200px" align="center" justify="center">
    </v-row>   

  </v-container>
</template>
<script>

export default {

    created(){
    
    //this.$hostname = window.location.hostname;
    //console.log("login hostname1: " + this.$hostname);


    //로그인 전역 이벤트 수신
    this.$EventBus.$on('loginresult', this.selectmenu);

    //화면이동 이벤트 수신
    this.$EventBus.$on('movepageresult', this.movepage);


    if(this.$session.exists("ACNT_IDX")){
        //키값이 있으면 로그인이 이미 된 경우
        this.$router.push('Welcome');   //로그인 페이지로 이동
    }

   },


    mounted() {

      //this.$hostname = window.location.hostname;
      //console.log("login hostname2: " + this.$hostname);

      this.checkbox = localStorage.getItem("SAVE_ID");
      
      if(this.checkbox){
      
        this.user_id = localStorage.getItem("LOGIN_ID");
      }

    },

    data: () => ({

        user_id : ""
      , user_pw : ""
      , loading:false
      , checkbox:false

    }),

    methods: {
      
      changelan(){
        localStorage.setItem("LOCALE", this.$i18n.locale);
        //팝업창 텍스트 영문화
        if(this.$i18n.locale == 'ko'){        
          this.$alert_option.confirmButtonText = "확인";
          this.$alert_option.cancelButtonText  = "취소";        
        }else{        
          this.$alert_option.confirmButtonText = "OK";
          this.$alert_option.cancelButtonText  = "Cancel";
        }
      },

      checkchange(value){
        
        if(value){
          localStorage.setItem("SAVE_ID", true);
        }else{
          localStorage.setItem("SAVE_ID", false);
        }
      },

      runjoin(){
        this.$router.push('/Join');
      },

      runpass(){
        this.$router.push('/Pass');
      },

      login(){
        
          if(this.user_id.length < 1){
            this.$alert(this.$t('login_error_accnt'));
            return;
          }
          if(this.user_pw.length < 1){
            this.$alert(this.$t('login_error_pw'));
            return;
          }
          
          localStorage.setItem("LOGIN_ID", this.user_id);

          this.loading = true;
          this.$http.post(this.$host+'/api/Login',{
              USER_ID: this.user_id
            , USER_PW: Buffer.from(this.user_pw).toString('base64')
          })
          .then((result)=>{

            this.loading = false;
            if(result.data.resultCode == 0){
                const user = result.data.resultData[0];

                if(user.STATE == 0){
                  this.$alert(this.$t('login_error_wait'));
                  return;
                }else if(user.STATE == 2){
                  this.$alert(this.$t('login_error_cancel'));
                  return;
                }

                if(user.GRADE < 10){
                  this.$alert(this.$t('login_error_cs'));
                  return;
                }

                this.$session.set("ADMIN_IDX",  user.ADMIN_IDX);  //ADMIN GROUP IDX
                this.$session.set("COM_IDX",    user.COM_IDX);    //COMPANY IDX
                this.$session.set("ACNT_IDX",   user.IDX);        //ACCOUNT IDX
                this.$session.set("GRADE",      user.GRADE);      //ACCOUNT GRADE
                this.$session.set("GRADE2",     user.GRADE2);      //ACCOUNT GRADE
                this.$session.set("COM_NAME",   user.COM_NAME);      //ACCOUNT GRADE
                this.$session.set("LOGIN_NAME", user.COM_NAME);      //ACCOUNT GRADE

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                
                //로그인 성공 전역 이벤트 발송
                this.$EventBus.$emit('loginresult');

                if(user.GRADE > 90){
                  //this.$router.push('ComWelcome'); //커스템 메인
                  this.$router.push('ComAcnt'); //커스템 메인
                }else if(user.GRADE >= 10){
                  //프로젝트 관리자
                  this.$router.push('Welcome'); //공지사항 메인
                }
                

            }else{
              this.$alert(this.$t('login_error'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t('login_error'));
          });


      },

    },


}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

.roundbg{
  border-radius: 25px;
  background: #ffffff;
  padding: 20px;
  padding-bottom: 30px;
}


</style>